const handleKeyboardNavigation = ({
  element,
  action,
  shadowDomContext
}) => {
  const escapeEvent = (event) => {
    if (event.key === "Escape") {
      action(event);
    }
  };
  const keyEvent = (event) => {
    const currentElement = event.composedPath()[0];
    if (event.key === "Tab") {
      if (!element) return;
      const hasElement = element.contains(currentElement);
      const hasShadowDomContext = shadowDomContext?.contains(currentElement);
      const isCurrentElement = currentElement === element;
      if (!hasElement && !hasShadowDomContext && !isCurrentElement) {
        action(event);
      }
    }
    if (event.key === "ArrowDown") {
      const nextElement = currentElement.nextElementSibling;
      if (element && !element.contains(nextElement)) {
        action(event);
      } else if (nextElement) {
        nextElement.focus();
      }
    }
    if (event.key === "ArrowUp") {
      const previousElement = currentElement.previousElementSibling;
      if (element && !element.contains(previousElement)) {
        action(event);
      } else if (previousElement) {
        previousElement.focus();
      }
    }
  };
  window.addEventListener("keydown", escapeEvent);
  window.addEventListener("keyup", keyEvent);
  return () => {
    window.removeEventListener("keydown", escapeEvent);
    window.removeEventListener("keyup", keyEvent);
  };
};
export {
  handleKeyboardNavigation
};
//# sourceMappingURL=handleKeyboardNavigation.js.map
